// App Names as const enum for type safety
export const enum AppName {
  Files = 'Memory',
  Match = 'Match',
  People = 'People',
  GoogleDrive = 'Google Drive',
  MicrosoftDrive = 'Microsoft Drive',
  Links = 'Links',
  LinkAddOns = 'linkAddOns',
  GoogleCalendar = 'Google Calendar',
  Feed = 'Feed'
}

// Chat app keys (subset of AppName used in chat)
export const enum ChatAppKeys {
  files = 'Files',
  people = 'People',
  links = 'Links',
  memory = 'Memory',
  code = 'Code',
  image = 'Image',
  sheet = 'Sheet',
  sources = 'Sources',
  doc = 'Doc',
  enhancedPeople = 'EnhancedPeople',
  conversationalPeople = 'ConversationalPeople',
  actions = 'actions',
  isAgentMode = 'isAgentMode',
  composioActions = 'composioActions',
  // Exa web search tools
  webSearchTool = 'webSearchTool',
  websiteExtractorTool = 'websiteExtractorTool',
  relatedContentTool = 'relatedContentTool',
  sourcedAnswerTool = 'sourcedAnswerTool',
  similarContentTool = 'similarContentTool'
}

// Toggleable apps (apps that can be enabled/disabled)
export const TOGGLEABLE_APPS = [
  AppName.People,
  AppName.Feed
] as const;

// Hidden apps (not shown in the UI)
export const HIDDEN_APPS = ['Team', 'Network'] as const;

// Disabled apps (shown but not usable)
export const DISABLED_APPS = [
  AppName.GoogleDrive,
  AppName.MicrosoftDrive,
  AppName.GoogleCalendar,
  AppName.Match
] as const;

export type ToggleableApp = typeof TOGGLEABLE_APPS[number];
export type HiddenApp = typeof HIDDEN_APPS[number];
export type DisabledApp = typeof DISABLED_APPS[number];

// Type for enabled apps state
export type EnabledAppsState = {
  [K in ToggleableApp]?: boolean;
};

// Type for chat apps state
export type ChatAppsState = {
  [K in ChatAppKeys]?: boolean;
};

// Default state for enabled apps
export const DEFAULT_ENABLED_APPS: EnabledAppsState = {
  [AppName.People]: true,
};

// Default state for chat apps
export const DEFAULT_CHAT_APPS: ChatAppsState = {
  [ChatAppKeys.files]: true,
  [ChatAppKeys.people]: true,
  [ChatAppKeys.links]: true,
  [ChatAppKeys.memory]: true,
  [ChatAppKeys.code]: true,
  [ChatAppKeys.image]: true,
  [ChatAppKeys.sheet]: true,
  [ChatAppKeys.sources]: true,
  [ChatAppKeys.doc]: true,
  [ChatAppKeys.enhancedPeople]: true,
  [ChatAppKeys.conversationalPeople]: true,
  [ChatAppKeys.actions]: false,
  [ChatAppKeys.isAgentMode]: false,
  [ChatAppKeys.composioActions]: false,
  [ChatAppKeys.webSearchTool]: false,
  [ChatAppKeys.websiteExtractorTool]: false,
  [ChatAppKeys.relatedContentTool]: false,
  [ChatAppKeys.sourcedAnswerTool]: false,
  [ChatAppKeys.similarContentTool]: false
};
